export default __webpack_public_path__ + "static/media/welcome-to-our-city.29c547a3.png";